<template>
  <div class="content">
    <div class="my-container">
      <el-button class="btn" :class="{active: isActive}" @click="myClick">
        <div class="content">
          <img src="/img/clock.png" v-if="isActive" />
          <img src="/img/clock-d.png" v-else />

          <!-- <img src="/img/clock-white.png" /> -->
        我的预约
          <span v-if="consulterTotal">({{ consulterTotal }})</span>
        </div>
      </el-button>
      <div class="appointmented">
        <el-button
          @click="btnClick(item.type, item, index)"
          class="btn"
          :class="{active: curIndex === index}"
          v-for="(item, index) in btnList"
          :key="index"
          v-if="item.isShow"
        >
          <div class="content" v-if="item.isShow">
            {{ item.text }}
            <span v-if="item.type === 'consultant' && consultantTotal">({{ consultantTotal }})</span>
          </div>
        </el-button>
      </div>
    </div>
    <div class="activate">
      <div
        class="activate-btn"
        v-for="(item, index) in filteredQuesList"
        :key="`status-${index}-${item.text || item.id || item.type}`"
      >
        <span> {{ item.text }}</span>
        <span class="right" @click="handleActivateClick(item)"> {{ item.btn }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import {consultOpenApi, checkConsultOpenStatusApi} from '../../api/counsult'
import {currentLoginUser} from '@/api/project'

export default {
  data() {
    return {
      curIndex: -1,
      isActive: false,
      isConsultantOpened: false, // 是否已开通咨询师
      loading: false, // 加载状态
      quesList: [
        {
          id: 0,
          text: '可被预约',
          btn: '开通',
          type: 'open'
        },
        {
          id: 1,
          text: '常见问题',
          btn: '查看',
          type: 'faq'
        }
      ],
      isAuthenticated: false,
      hasManageAuth :false
    }
  },
  props: {
    consultantTotal: {
      type: Number,
      default: 0
    },
    consulterTotal: {
      type: Number,
      default: 0
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  async created() {
    currentLoginUser().then(res=>{
      if(res.code === 200) {
        if(res.data?.hasManageAuth) {
          this.hasManageAuth = true
        }
      }
    })
    // 组件创建时检查开通状态
    await this.checkOpenStatus()
  },
  computed: {
    ...mapState(['UserInfo']),
    btnList() {
      return [
        {
          type: 'consultant',
          text: '预约我的',
          isShow: true
        },
        {
          type: 'col',
          text: '我收藏的',
          isShow: true
        },
        {
          type: 'guanzhu',
          text: '我的关注',
          isShow: true
        },
        {
          type: 'fans',
          text: '我的粉丝',
          isShow: true
        },
        {
          type: 'detail',
          text: '我的详情',
          isShow: true
        },
        {
          type: 'all',
          text: '全站预约',
          isShow: this.hasManageAuth
        }
      ]
    },
    // 检查用户是否已入驻
    isEntered() {
      return this.UserInfo && this.UserInfo.employeeId
    },
    // 过滤后的按钮列表（根据开通状态显示）
    filteredQuesList() {
      return this.quesList.filter(item => {
        if (item.type === 'open') {
          // 如果已开通，不显示开通按钮
          return !this.isConsultantOpened
        } else {
          return true
        }
      })
    }
  },
  methods: {
    // 检查开通状态
    async checkOpenStatus() {
      if (this.loading) return
      this.loading = true
      const res = await checkConsultOpenStatusApi()
      if (res?.code === 200) {
        if (res.data.openConsultFlag === 1) {
          this.isConsultantOpened = true
        }
        if (res.data.realNameAuthenticatedFlag === 1) {
          // 实名认证
          this.isAuthenticated = true
        }
        if (res.data.openConsultFlag === 0) {
          // 是否入驻个人
          this.isEntered = true
        }
      }
    },

    btnClick(type, item, index) {
      
      if(this.isLoading) return;
      this.isActive = false
      if (type === 'guanzhu' || type === 'fans') {
        this.$emit('consulterClick', type, index)
        return
      }
      if (this.curIndex === index) {
        this.curIndex = -1
        this.$emit('consulterClick', type, this.curIndex)
        return
      }
      this.curIndex = index
      this.$emit('consulterClick', type, this.curIndex)
    },
    myClick() {
      if(this.isLoading) return;
      // 如果已经选中，则刷新数据
      this.curIndex = -1

      this.isActive = !this.isActive

      if (this.isActive) {
        this.$emit('consulterClick', 'consulter', -2)
      } else {
        this.$emit('consulterClick', 'consulter', -1)
      }
    },
    // 处理激活按钮点击
    handleActivateClick(item) {
      if (item.type === 'open') {
        // 判断是否登录，如果没有登录，跳转到登陆页面
        if (!this.UserInfo || !this.UserInfo.id) {
          this.$router.push('/login')
          return
        }

        this.handleOpenClick()
      } else if (item.type === 'faq') {
        this.handleFaqClick()
      }
    },
    // 处理开通按钮点击
    async handleOpenClick() {
      // 检查实名认证和入驻状态
      if (!this.isAuthenticated) {
        this.$message.warning('请先完成实名认证')
        // 跳转实名认证
        this.$router.push('/authenticationUser')
        return
      }

      if (!this.isEntered) {
        this.$message.warning('请先完成入驻')
        // 跳转入驻
        this.$router.push('/enter')
        return
      }

      // 显示确认对话框
      try {
        await this.$confirm(
          '开通后为休息状态，您需要去您的详情页，设置各项信息后，再点击"开启"按钮，才可变为上线状态并可接受预约。确定要开通吗？',
          '确认开通',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        )

        // 用户确认，调用开通接口
        await this.openConsultant()
      } catch (error) {
        // 用户取消或接口调用失败
        if (error !== 'cancel') {
          console.error('开通失败:', error)
        }
      }
    },
    // 调用开通接口
    async openConsultant() {
      try {
        const res = await consultOpenApi()
        if (res.code !== 200) {
          this.$message.success(res.msg)
          return
        }
        this.$message.success('开通成功！')

        // 更新开通状态å
        this.isConsultantOpened = true

        // 触发父组件刷新数据
        this.$emit('openSuccess')

        // 自动切换到"我的详情"页面
        this.btnClick('detail', null, 4) // 4是"我的详情"按钮的索引
      } catch (error) {
        if (error.message === '请先实名认证') {
          setTimeout(() => {
            this.$router.push('/authenticationUser')
          }, 1000)
          return
        }
        console.error('开通接口调用失败:', error)
        this.$message.error(error)
      }
    },
    // 处理常见问题点击
    handleFaqClick() {
      // 跳转到常见问题页面
      this.$router.push('/faq?tag=咨询')
    },
    // 重置选中状态
    resetActive() {
      this.curIndex = -1
      this.isActive = false
    }
  }
}
</script>

<style lang="scss" scoped>
.my-container {
  width: 290px;
  height: 316px;
  background: #ffffff;
  border-radius: 8px 8px 8px 8px;
  padding: 30px 15px;
  box-sizing: border-box;
  .appointmented {
    .btn {
      width: 125px;
      height: 50px;
      margin-top: 20px;
      margin: 20px 0px 0 0px;
      background: rgba(90, 211, 205, 0.08);
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #5ad3cd;
      font-weight: 500;
      font-size: 18px;
      color: #5ad3cd;
      &.active {
        background: #5ad3cd;
        color: #ffffff;
      }
      &:nth-child(odd) {
        margin-right: 9px;
      }
    }
  }
  .btn {
    width: 260px;
    height: 50px;
    background: rgba(90, 211, 205, 0.08);
    color: #5ad3cd;
    border: 1px solid #5ad3cd;
    img {
      width: 20px;
      height: 20px;
      margin-right: 8px;
    }
    .content {
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 500;
      font-size: 18px;
    }
    &.active {
      background: #5ad3cd;
      color: #ffffff;
    }
  }
}
.activate {
  .activate-btn {
    padding: 0 24px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 500;
    font-size: 18px;
    color: #333333;
    width: 290px;
    height: 60px;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    margin-top: 16px;
    .right {
      width: 60px;
      height: 29px;
      border-radius: 57px 57px 57px 57px;
      border: 1px solid #5ad3cd;
      font-family: PingFang HK, PingFang HK;
      font-weight: 400;
      font-size: 18px;
      color: #5ad3cd;
      text-align: center;
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        background: #5ad3cd;
        color: #ffffff;
      }

      &:active {
        transform: scale(0.95);
      }
    }
  }
}
</style>
